import { render, staticRenderFns } from "./Hlw.vue?vue&type=template&id=8d2d2eae&scoped=true"
import script from "./Hlw.vue?vue&type=script&lang=js"
export * from "./Hlw.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8d2d2eae",
  null
  
)

export default component.exports